import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';
import { AssignedTenantDto } from './assigned-tenant.dto';

@Api('api/agentic-cx/free-switch-instance')
export class FreeSwitchInstanceDto extends DtoHasApi {
  id: string;
  name: string;
  ipAddress: string;
  isActive: boolean;
  isDefault: boolean;
  webRtcHost?: string;
  assignedTenants?: AssignedTenantDto[];
}